import config from '../config'

export default [
  {
    path: config.basePath,
    name: 'module-retail-sale',
    meta: { requiresAuth: true, pageEmpty: true },
    component: () => import('../views/Index.vue')
  },
  {
    path: `${config.basePath}/customer-display`,
    name: 'retail-sale-customer-display',
    meta: { requiresAuth: false, pageEmpty: true },
    component: () => import('../views/CustomerDisplay.vue')
  }
]
